import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { Member } from '@/types';

interface GetAllMembersResponse {
  data?: Member[];
  detail?: string;
}

export const getAllMembersByOrg = async (
  organizationId?: string,
): Promise<GetAllMembersResponse> => {
  const orgId = organizationId || useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/org-members/${orgId}/invites`,
    target: 'platform',
    method: 'GET',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to get all members' };
  }

  return response as GetAllMembersResponse;
};
